module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加学生作品"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "userVideoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.userVideoParams,
      "rules": _vm.userVideoRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.userVideoParams.title),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "title", $$v)
      },
      expression: "userVideoParams.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.userVideoParams.uid),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "uid", _vm._n($$v))
      },
      expression: "userVideoParams.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分组",
      "prop": "ageGroup"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.userVideoParams.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "ageGroup", _vm._n($$v))
      },
      expression: "userVideoParams.ageGroup"
    }
  }, _vm._l((_vm.$constant.userVideoType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生作品",
      "prop": "videoUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.videoChange,
      "on-success": _vm.videoSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "video/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.videoFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品封面",
      "prop": "videoPicUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.videoPicChange,
      "on-success": _vm.videoPicSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "image/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.videoPicFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抖音链接",
      "prop": "douyinUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "抖音分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.douyinUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "douyinUrl", $$v)
      },
      expression: "userVideoParams.douyinUrl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "小红书链接",
      "prop": "xhsUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "小红书分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.xhsUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "xhsUrl", $$v)
      },
      expression: "userVideoParams.xhsUrl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "视频号链接",
      "prop": "channelsUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "视频号分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.channelsUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "channelsUrl", $$v)
      },
      expression: "userVideoParams.channelsUrl"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddModal
    },
    on: {
      "click": _vm.addUserVideo
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efa74a02","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/modal/AddUserVideoModal.vue
// module id = 1999
// module chunks = 8